import { AaasPackage, GroupedPackages, IntpWebsite, StpCounterResponse } from '@va/aaas/shared/types';
import { AxiosHttpClient } from '@va/api-client';
import { VisaApiResponse } from '@visitor-analytics/3as-sdk';
import { AxiosResponse } from 'axios';
import * as Config from 'Config';
import { groupBy } from 'lodash';

//TODO move class functions to apiGateway
class AaasApiClient extends AxiosHttpClient {
  private static apiClientInstance?: AaasApiClient;

  private constructor() {
    super(`${Config.gatewayApiUrl}/v2/3as`);
  }

  public static getInstance() {
    if (!this.apiClientInstance) {
      this.apiClientInstance = new AaasApiClient();
    }
    return this.apiClientInstance;
  }

  public getWebsiteByExternalWebsiteId = async (externalWebsiteId: string): Promise<IntpWebsite> => {
    const response = await this.instance.get<never, AxiosResponse<VisaApiResponse<IntpWebsite>>>(
      `/websites/${externalWebsiteId}`,
    );

    return response.data.payload;
  };

  public getStpRates = async (websiteId: string) => {
    const response = await this.instance.get<never, AxiosResponse<VisaApiResponse<StpCounterResponse>>>(
      `/stp-rates/websites/${websiteId}`,
    );
    return response.data.payload;
  };

  public getPackages = async () => {
    const response = await this.instance.get<never, AxiosResponse<VisaApiResponse<AaasPackage[]>>>('/packages');

    return groupBy(response.data.payload, 'period') as GroupedPackages;
  };

  public getTheme = async () => {
    const response = await this.instance.get<never, any>('/theme');

    return response.data.payload;
  };
}

export const AaasClient = AaasApiClient.getInstance();
